var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFav = function SvgFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    className: "fav_svg__design-iconfont"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.69 26.49-4.494 2.504a1 1 0 0 1-1.467-1.07l1-5.012a1 1 0 0 0-.303-.932l-3.768-3.466a1 1 0 0 1 .56-1.73l5.105-.602a1 1 0 0 0 .79-.572l2.157-4.653a1 1 0 0 1 1.814 0l2.157 4.653a1 1 0 0 0 .79.572l5.104.603a1 1 0 0 1 .56 1.729l-3.767 3.466a1 1 0 0 0-.304.932l1.001 5.013a1 1 0 0 1-1.467 1.07l-4.495-2.504a1 1 0 0 0-.973 0Z",
    fill: "currentColor"
  })));
};
export default SvgFav;